// expand

const expandButtonsAll = document.querySelectorAll("._jsExpand");

expandButtonsAll.forEach(expandButton => {
	expandButton.addEventListener("click", function() {

		const expanded = expandButton.getAttribute("aria-expanded");
		const targetId = expandButton.getAttribute("aria-controls");
		const target = document.getElementById(targetId);

		// if already expanded, close

		if (expanded == "true") {
			this.setAttribute("aria-expanded", "false");
			target.classList.remove("open");
		}

		else {

			// if part of group, close all in group first

			if (this.hasAttribute("data-group")) {
				const dataGroupValue = this.getAttribute("data-group");
				const dataGroupSiblings = document.querySelectorAll("[data-group=" + dataGroupValue + "]");

				dataGroupSiblings.forEach(dataGroup => {
					if (dataGroup.classList.contains("_jsExpand")) {
						dataGroup.setAttribute("aria-expanded", "false");
					}
					if (dataGroup.classList.contains("_jsExpandable")) {
						dataGroup.classList.remove("open");
					}
				});
			}

			// open this

			this.setAttribute("aria-expanded", "true");
			target.classList.add("open");
			target.focus();
		}
	});
});

// for search expand, move focus to input field when expanded

document.addEventListener("DOMContentLoaded", () => {
	const headerSearch = document.getElementById("headerSearch");
	if (headerSearch) {
		document.getElementById("headerSearch").addEventListener("focus", function() {
			document.getElementById("headerSearchInput").focus();
		});
	}
});




// close header menu if pressing escape while focus is on element inside

const headerMenu = document.querySelector(".globalHeader .menu");
const headerMenuExpandButton = document.querySelector(".globalHeader .menuButton");

document.addEventListener("keydown", (e) => {
	// if pressed escape
	if (e.key === "Escape") {
		// if element in menu has focus
		if (headerMenu.contains(document.activeElement)) {
			// close menu
			headerMenu.classList.remove("open");
			// set focus back on menu expand button and unexpand it
			headerMenuExpandButton.setAttribute("aria-expanded", "false");
			headerMenuExpandButton.focus();
		}
	}
});
